import React from 'react';
import { View, Text } from 'react-native';
import { Button, Hr } from 'LocalGluons';
import { func } from 'prop-types';
import { t } from 'Locale';
import defaultStyles, { buttonStyle } from './PageStyles.jss';

/**
 * @typedef {{ onChange(): void, onCancel(): void }} Props
 */

/**
 * @param {Props} props
 */
const ChangeCredentials = ({ onChange, onCancel }) => (
    <View style={defaultStyles.container}>
        <Text style={defaultStyles.title}>{t('CHANGE_CREDENTIALS.TITLE')}</Text>
        <Hr />
        <Text style={[defaultStyles.description, { height: 120 }]}>
            {t('CHANGE_CREDENTIALS.DESCRIPTION')}
        </Text>
        <View style={defaultStyles.buttonsContainer}>
            <Button
                style={buttonStyle}
                title={t('CHANGE_CREDENTIALS.CHANGE_NOW')}
                onPress={onChange}
            />
            <Button
                style={buttonStyle}
                title={t('CHANGE_CREDENTIALS.CHANGE_LATER')}
                onPress={onCancel}
                isSecondary
            />
        </View>
    </View>
);

ChangeCredentials.propTypes = {
    onChange: func.isRequired,
    onCancel: func.isRequired
};

export default ChangeCredentials;
